import { render, staticRenderFns } from "./CircleButton.vue?vue&type=template&id=fa571c12&scoped=true&"
import script from "./CircleButton.vue?vue&type=script&lang=js&"
export * from "./CircleButton.vue?vue&type=script&lang=js&"
import style0 from "./CircleButton.vue?vue&type=style&index=0&id=fa571c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa571c12",
  null
  
)

export default component.exports